import React, { useEffect, useState } from "react";
import "./Gallery.css";
import eye from "../../Assets/eye.png";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Gallery() {
  const [galleryData, setGalleryData] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [loading, setLoading] = useState(true);

  const API_BASE = "https://backend-ourcountryourpeople-4.onrender.com";

  /* ---------------- AOS INIT ---------------- */
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out-cubic",
      once: true,
      offset: 100,
    });
  }, []);

  /* ---------------- FETCH GALLERY ---------------- */
  const fetchGallery = async () => {
    try {
      const response = await fetch(`${API_BASE}/api/gallery`);
      if (!response.ok) throw new Error("Failed to fetch gallery");

      const data = await response.json();

      // Use DB Base64 images directly
      const sanitizedData = data.map((item) => ({
        ...item,
        img: item.img || null, // Base64 string from backend
      }));

      setGalleryData(sanitizedData);

      // Refresh AOS after data loads
      setTimeout(() => AOS.refresh(), 100);
    } catch (error) {
      console.error("Error fetching gallery:", error);
      setGalleryData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGallery();
  }, []);

  return (
    <>
      <div className="gallery-wrapper">
        <p className="breadcrumb5" data-aos="fade-right">
          Home &nbsp;›&nbsp; Gallery
        </p>

        <h2 className="gallery-title" data-aos="fade-up" data-aos-delay="100">
          Our Activities
        </h2>

        <div className="gallery-grid">
          {/* 🔄 Loading */}
          {loading && (
            <p className="no-image" data-aos="fade-up">
              Loading...
            </p>
          )}

          {/* 🚫 No Images */}
          {!loading && galleryData.length === 0 && (
            <p className="no-image" data-aos="fade-up">
              No Image Found
            </p>
          )}

          {/* ✅ Images */}
          {!loading &&
            galleryData.length > 0 &&
            galleryData.map((item, index) => (
              <div
                className="gallery-card"
                key={index}
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <img
                  src={item.img || "/no-image.png"}
                  alt={item.title || "activity"}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/no-image.png";
                  }}
                />

                <div className="overlay">
                  <span
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedImage(item.img);
                    }}
                  >
                    <img src={eye} alt="view" />
                  </span>
                </div>
              </div>
            ))}
        </div>
      </div>

      {/* 🔍 MODAL PREVIEW */}
      {selectedImage && (
        <div className="modal" onClick={() => setSelectedImage(null)}>
          <img
            src={selectedImage}
            className="modal-img"
            alt="preview"
            onError={(e) => {
              e.target.src = "/no-image.png";
            }}
          />
        </div>
      )}
    </>
  );
}
